import { assign } from 'fsm';
import Raven from 'raven-js';
import { performCRMSearch } from './client';
export const machine = {
  initial: 'idle',
  states: {
    idle: {
      on: {
        SEARCH: {
          target: 'loading',
          actions: ['setQuery']
        },
        SELECT_BY_IDS: {
          target: 'idle',
          actions: ['setByIdsData']
        }
      }
    },
    loading: {
      invoke: {
        src: 'performCRMSearch',
        onDone: {
          target: 'idle',
          actions: ['setData', 'clearError']
        },
        onError: {
          target: 'error',
          actions: ['setError', 'logError']
        }
      },
      on: {
        SEARCH: {
          target: 'loading',
          actions: ['setQuery']
        }
      },
      tags: ['loading']
    },
    error: {
      on: {
        SEARCH: {
          target: 'loading',
          actions: ['setQuery']
        },
        RETRY: 'loading'
      },
      tags: ['error']
    }
  },
  actions: {
    setQuery: assign((_context, event) => {
      return {
        query: event.query
      };
    }),
    setData: assign((_context, event) => {
      return {
        data: event.data
      };
    }),
    setError: assign((_context, event) => {
      var _event$data;
      return {
        error: ((_event$data = event.data) === null || _event$data === void 0 ? void 0 : _event$data.message) || 'An error occurred'
      };
    }),
    clearError: assign(() => {
      return {
        error: null
      };
    }),
    logError: (_context, event) => {
      Raven.captureException(event.data);
    },
    setByIdsData: assign((_context, event) => {
      return {
        data: {
          results: event.selectionIds,
          total: event.selectionIds.length
        },
        error: null
      };
    })
  },
  guards: {},
  services: {
    performCRMSearch
  }
};